(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity]');

    if (!button) {
      return;
    }

    const control = button.closest('.cart-item__quantity-control');
    const input = control ? control.querySelector('input') : null;

    if (!input) {
      return;
    }

    const currentValue = Number.parseInt(input.value, 10) || 0;
    const minimumValue = Number.parseInt(input.getAttribute('min'), 10) || 0;
    const change = button.dataset.cartQuantity === 'increase' ? 1 : -1;

    input.value = Math.max(minimumValue, currentValue + change);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!window.PLNBCollectionDynamicLoader) {
    window.PLNBCollectionDynamicLoader = true;

    var activeCollectionController = null;

    function getCollectionRoot() {
      return document.querySelector('[data-collection-main]');
    }

    function setLoading(root, isLoading) {
      if (!root) {
        return;
      }

      root.classList.toggle('is-loading', isLoading);
      root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function isSearchUrl(destinationUrl) {
      var requestUrl = new URL(destinationUrl, window.location.origin);
      var pathParts = requestUrl.pathname.split('/').filter(Boolean);

      return pathParts[pathParts.length - 1] === 'search';
    }

    function getSectionRequestUrl(destinationUrl, sectionId) {
      var requestUrl = new URL(destinationUrl, window.location.origin);
      var requestSectionId = isSearchUrl(destinationUrl) ? 'search' : sectionId;

      requestUrl.searchParams.set('section_id', requestSectionId);
      return requestUrl.toString();
    }

    function getCleanUrl(destinationUrl) {
      var cleanUrl = new URL(destinationUrl, window.location.origin);
      cleanUrl.searchParams.delete('section_id');
      return cleanUrl;
    }

    function updateHistory(destinationUrl, shouldPush) {
      if (!shouldPush) {
        return;
      }

      var cleanUrl = getCleanUrl(destinationUrl);
      window.history.pushState({ plnbCollection: true }, '', cleanUrl.toString());
    }

    function replaceCollectionSection(currentRoot, incomingRoot) {
      currentRoot.replaceWith(incomingRoot);
    }

    function setSearchHeader(root, parsedDocument, destinationUrl) {
      var heading = root.querySelector('.collection-main__header h1');
      var description = root.querySelector('.collection-main__description');
      var fetchedSummary = parsedDocument.querySelector('.search-page__results-header p');
      var fetchedStateText = parsedDocument.querySelector('.search-page__state p');
      var cleanUrl = getCleanUrl(destinationUrl);
      var searchQuery = cleanUrl.searchParams.get('q') || '';
      var searchInput = root.querySelector('.collection-main__search input[name="q"]');

      if (heading) {
        heading.textContent = root.dataset.searchHeading || 'Search';
      }

      if (!description && heading) {
        description = document.createElement('div');
        description.className = 'collection-main__description';
        heading.insertAdjacentElement('afterend', description);
      }

      if (description) {
        if (fetchedSummary) {
          description.textContent = fetchedSummary.textContent;
        } else if (fetchedStateText) {
          description.textContent = fetchedStateText.textContent;
        } else {
          description.textContent = '';
        }
      }

      if (searchInput) {
        searchInput.value = searchQuery;
      }
    }

    function clearActiveCollectionLinks(root) {
      root.querySelectorAll('.collection-main__collection-link').forEach(function(link) {
        link.classList.remove('is-active');
        link.removeAttribute('aria-current');
      });
    }

    function renderEmptySearchState(root, parsedDocument, grid) {
      var fetchedTitle = parsedDocument.querySelector('.search-page__state h2');
      var fetchedMessage = parsedDocument.querySelector('.search-page__state p');
      var emptyState = document.createElement('div');
      var title = document.createElement('strong');
      var message = document.createElement('span');

      emptyState.className = 'collection-main__empty collection-main__empty-state';
      title.textContent = fetchedTitle ? fetchedTitle.textContent : root.dataset.searchEmpty || 'No results';
      message.textContent = fetchedMessage ? fetchedMessage.textContent : '';

      emptyState.appendChild(title);

      if (message.textContent) {
        emptyState.appendChild(message);
      }

      grid.appendChild(emptyState);
    }

    function renderSearchResults(root, parsedDocument, destinationUrl) {
      var grid = root.querySelector('[data-collection-products]');
      var searchResults = parsedDocument.querySelector('.search-page__results');
      var searchPagination = parsedDocument.querySelector('.search-page__pagination');
      var renderedCards = 0;

      if (!grid) {
        return false;
      }

      setSearchHeader(root, parsedDocument, destinationUrl);
      clearActiveCollectionLinks(root);
      grid.innerHTML = '';

      if (searchResults) {
        searchResults.querySelectorAll('.product-card').forEach(function(card) {
          grid.appendChild(card);
          renderedCards += 1;
        });
      }

      if (renderedCards === 0) {
        renderEmptySearchState(root, parsedDocument, grid);
      }

      if (searchPagination) {
        var pagination = document.createElement('div');
        pagination.className = 'collection-main__pagination';
        pagination.innerHTML = searchPagination.innerHTML;
        grid.appendChild(pagination);
      }

      return true;
    }

    function loadCollectionUrl(destinationUrl, options) {
      var root = getCollectionRoot();
      var sectionId = root ? root.dataset.sectionId : '';
      var shouldPush = !options || options.push !== false;

      if (!root || !sectionId) {
        window.location.href = destinationUrl;
        return;
      }

      if (activeCollectionController) {
        activeCollectionController.abort();
      }

      activeCollectionController = new AbortController();
      setLoading(root, true);

      fetch(getSectionRequestUrl(destinationUrl, sectionId), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        signal: activeCollectionController.signal
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Section request failed');
          }

          return response.text();
        })
        .then(function(html) {
          var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          var incomingCollection = parsedDocument.querySelector('[data-collection-main]');
          var liveRoot = getCollectionRoot();

          if (!liveRoot) {
            window.location.href = destinationUrl;
            return;
          }

          if (incomingCollection) {
            replaceCollectionSection(liveRoot, incomingCollection);
            updateHistory(destinationUrl, shouldPush);
            return;
          }

          if (renderSearchResults(liveRoot, parsedDocument, destinationUrl)) {
            updateHistory(destinationUrl, shouldPush);
            return;
          }

          window.location.href = destinationUrl;
        })
        .catch(function(error) {
          if (error.name === 'AbortError') {
            return;
          }

          window.location.href = destinationUrl;
        })
        .finally(function() {
          setLoading(getCollectionRoot(), false);
        });
    }

    function getSearchUrlFromForm(form) {
      var root = getCollectionRoot();
      var queryInput = form.querySelector('input[name="q"]');
      var query = queryInput ? queryInput.value.trim() : '';
      var searchUrl = new URL(form.action, window.location.origin);
      var formData = new FormData(form);

      if (!query) {
        return root && root.dataset.allProductsUrl ? root.dataset.allProductsUrl : searchUrl.toString();
      }

      formData.forEach(function(value, key) {
        if (value !== '') {
          searchUrl.searchParams.append(key, value);
        }
      });

      return searchUrl.toString();
    }

    document.addEventListener('click', function(event) {
      var target = event.target;

      if (!target.closest) {
        return;
      }

      var root = target.closest('[data-collection-main]');
      var link = target.closest('a');

      if (!root || !link) {
        return;
      }

      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
        return;
      }

      if (link.target || link.hasAttribute('download')) {
        return;
      }

      if (link.closest('.product-card')) {
        return;
      }

      if (!link.closest('.collection-main__collection-nav') && !link.closest('.collection-main__pagination')) {
        return;
      }

      event.preventDefault();
      loadCollectionUrl(link.href);
    });

    document.addEventListener('submit', function(event) {
      if (!event.target.closest) {
        return;
      }

      var form = event.target.closest('[data-collection-search]');

      if (!form) {
        return;
      }

      event.preventDefault();
      loadCollectionUrl(getSearchUrlFromForm(form));
    });

    window.addEventListener('popstate', function() {
      if (!getCollectionRoot()) {
        return;
      }

      loadCollectionUrl(window.location.href, { push: false });
    });

    document.addEventListener('keydown', function(event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
        return;
      }

      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
      }

      if (event.target.closest && event.target.closest('a, button, input, textarea, select, [contenteditable="true"]')) {
        return;
      }

      var collection = document.querySelector('[data-collection-main]');

      if (!collection) {
        return;
      }

      var linkSelector = event.key === 'ArrowLeft'
        ? '.collection-main__pagination .prev a'
        : '.collection-main__pagination .next a';
      var link = collection.querySelector(linkSelector);

      if (!link) {
        return;
      }

      event.preventDefault();
      loadCollectionUrl(link.href);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function initFooterNewsletter(scope) {
    (scope || document).querySelectorAll('.site-footer__newsletter-form').forEach(function(form) {
      if (form.dataset.newsletterReady === 'true') {
        return;
      }

      form.dataset.newsletterReady = 'true';

      form.addEventListener('submit', async function(event) {
        event.preventDefault();

        var submitButton = form.querySelector('[data-newsletter-submit]');
        var controls = form.querySelector('[data-newsletter-controls]');
        var successMessage = form.querySelector('[data-newsletter-message]');
        var errorsContainer = form.querySelector('[data-newsletter-errors]');

        form.setAttribute('aria-busy', 'true');
        if (submitButton) {
          submitButton.disabled = true;
        }

        if (successMessage) {
          successMessage.hidden = true;
        }

        if (errorsContainer) {
          errorsContainer.hidden = true;
          errorsContainer.innerHTML = '';
        }

        try {
          var response = await fetch(form.action, {
            method: 'POST',
            headers: {
              'Accept': 'text/html',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams(new FormData(form)).toString()
          });

          var html = await response.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var returnedForm = doc.querySelector('[data-newsletter-form]');
          var returnedErrors = returnedForm && returnedForm.querySelector('[data-newsletter-errors]');
          var subscribed = returnedForm && returnedForm.classList.contains('is-subscribed');

          if (subscribed) {
            if (controls) {
              controls.hidden = true;
            }
            if (successMessage) {
              successMessage.hidden = false;
            }
            return;
          }

          if (returnedErrors && returnedErrors.innerHTML.trim() !== '') {
            if (errorsContainer) {
              errorsContainer.innerHTML = returnedErrors.innerHTML;
              errorsContainer.hidden = false;
            }
            return;
          }

          if (errorsContainer) {
            errorsContainer.textContent = 'Something went wrong. Please try again.';
            errorsContainer.hidden = false;
          }
        } catch (error) {
          if (errorsContainer) {
            errorsContainer.textContent = 'Something went wrong. Please try again.';
            errorsContainer.hidden = false;
          }
        } finally {
          form.removeAttribute('aria-busy');
          if (controls && !controls.hidden && submitButton) {
            submitButton.disabled = false;
          }
        }
      });
    });
  }

  initFooterNewsletter(document);
  document.addEventListener('shopify:section:load', function(event) {
    initFooterNewsletter(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  function initHomeHeroSlideshows(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-home-hero-slideshow]').forEach(function(slideshow) {
      var slides = Array.prototype.slice.call(slideshow.querySelectorAll('[data-home-hero-slide]'));

      if (slideshow._homeHeroTimer) {
        window.clearInterval(slideshow._homeHeroTimer);
      }

      if (slides.length <= 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        slides.forEach(function(slide, index) {
          slide.classList.toggle('is-active', index === 0);
          slide.tabIndex = index === 0 ? 0 : -1;
        });
        return;
      }

      var activeIndex = slides.findIndex(function(slide) {
        return slide.classList.contains('is-active');
      });

      if (activeIndex < 0) {
        activeIndex = 0;
      }

      function showSlide(nextIndex) {
        slides.forEach(function(slide, index) {
          var isActive = index === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.tabIndex = isActive ? 0 : -1;
        });

        activeIndex = nextIndex;
      }

      slideshow._homeHeroTimer = window.setInterval(function() {
        showSlide((activeIndex + 1) % slides.length);
      }, 3000);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initHomeHeroSlideshows(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initHomeHeroSlideshows(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
  function scheduleProductRailNavSync(track) {
    window.requestAnimationFrame(function() {
      syncProductRailNav(track);

      window.requestAnimationFrame(function() {
        syncProductRailNav(track);
      });
    });

    window.setTimeout(function() {
      syncProductRailNav(track);
    }, 250);
  }

  function syncProductRailNav(track) {
    var rail = track.closest('.product-rail');
    var previousButton = rail && rail.querySelector('[data-product-rail-scroll="previous"]');
    var nextButton = rail && rail.querySelector('[data-product-rail-scroll="next"]');

    if (!previousButton || !nextButton) {
      return;
    }

    var maxScroll = track.scrollWidth - track.clientWidth;
    var hasOverflow = maxScroll > 2;

    if (!hasOverflow) {
      previousButton.setAttribute('aria-disabled', 'true');
      nextButton.setAttribute('aria-disabled', 'true');
      return;
    }

    previousButton.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
    nextButton.setAttribute('aria-disabled', track.scrollLeft >= maxScroll - 2 ? 'true' : 'false');
  }

  function productRailScrollStep(track) {
    return track.clientWidth * 0.92;
  }

  function initProductRails(scope) {
    (scope || document).querySelectorAll('[data-product-rail-track]').forEach(function(track) {
      if (track.dataset.productRailReady === 'true') {
        scheduleProductRailNavSync(track);
        return;
      }

      track.dataset.productRailReady = 'true';
      scheduleProductRailNavSync(track);

      track.addEventListener('scroll', function() {
        window.requestAnimationFrame(function() {
          syncProductRailNav(track);
        });
      });

      window.addEventListener('resize', function() {
        scheduleProductRailNavSync(track);
      });
    });
  }

  initProductRails(document);
  window.addEventListener('load', function() {
    initProductRails(document);
  });
  document.addEventListener('shopify:section:load', function(event) {
    initProductRails(event.target);
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-product-rail-scroll]');

    if (!button) {
      return;
    }

    var rail = button.closest('.product-rail');
    var track = rail && rail.querySelector('[data-product-rail-track]');

    if (!track) {
      return;
    }

    syncProductRailNav(track);

    if (button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var direction = button.getAttribute('data-product-rail-scroll') === 'next' ? 1 : -1;
    track.scrollBy({ left: direction * productRailScrollStep(track), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function scheduleProductRecommendationsNavSync(track) {
    window.requestAnimationFrame(function() {
      syncProductRecommendationsNav(track);

      window.requestAnimationFrame(function() {
        syncProductRecommendationsNav(track);
      });
    });

    window.setTimeout(function() {
      syncProductRecommendationsNav(track);
    }, 250);
  }

  function syncProductRecommendationsNav(track) {
    var section = track.closest('[data-product-recommendations]');
    var previousButton = section && section.querySelector('[data-recommendations-scroll="previous"]');
    var nextButton = section && section.querySelector('[data-recommendations-scroll="next"]');

    if (!previousButton || !nextButton) {
      return;
    }

    var maxScroll = track.scrollWidth - track.clientWidth;
    var hasOverflow = maxScroll > 2;

    if (!hasOverflow) {
      previousButton.setAttribute('aria-disabled', 'true');
      nextButton.setAttribute('aria-disabled', 'true');
      return;
    }

    previousButton.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
    nextButton.setAttribute('aria-disabled', track.scrollLeft >= maxScroll - 2 ? 'true' : 'false');
  }

  function productRecommendationsScrollStep(track) {
    return track.clientWidth * 0.92;
  }

  function initProductRecommendations(scope) {
    (scope || document).querySelectorAll('[data-product-recommendations]').forEach(function(section) {
      var url = section.dataset.url;

      if (!section.dataset.recommendationsObserverBound && url) {
        section.dataset.recommendationsObserverBound = 'true';

        var loadRecommendations = function(entries, observer) {
          if (!entries[0].isIntersecting) {
            return;
          }

          observer.unobserve(section);

          fetch(url)
            .then(function(response) {
              return response.text();
            })
            .then(function(text) {
              var html = document.createElement('div');
              html.innerHTML = text;
              var recommendations = html.querySelector('[data-product-recommendations]');

              if (recommendations && recommendations.innerHTML.trim().length) {
                section.innerHTML = recommendations.innerHTML;
                section.classList.remove('product-recommendations--empty');
                initProductRecommendations(section);
              }
            });
        };

        var observer = new IntersectionObserver(loadRecommendations, { rootMargin: '0px 0px 240px 0px' });
        observer.observe(section);
      }

      section.querySelectorAll('[data-recommendations-track]').forEach(function(track) {
        if (track.dataset.recommendationsReady === 'true') {
          scheduleProductRecommendationsNavSync(track);
          return;
        }

        track.dataset.recommendationsReady = 'true';
        scheduleProductRecommendationsNavSync(track);

        track.addEventListener('scroll', function() {
          window.requestAnimationFrame(function() {
            syncProductRecommendationsNav(track);
          });
        });

        window.addEventListener('resize', function() {
          scheduleProductRecommendationsNavSync(track);
        });
      });
    });
  }

  initProductRecommendations(document);
  window.addEventListener('load', function() {
    initProductRecommendations(document);
  });
  document.addEventListener('shopify:section:load', function(event) {
    initProductRecommendations(event.target);
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-recommendations-scroll]');

    if (!button) {
      return;
    }

    var section = button.closest('[data-product-recommendations]');
    var track = section && section.querySelector('[data-recommendations-track]');

    if (!track) {
      return;
    }

    syncProductRecommendationsNav(track);

    if (button.getAttribute('aria-disabled') === 'true') {
      return;
    }

    var direction = button.getAttribute('data-recommendations-scroll') === 'next' ? 1 : -1;
    track.scrollBy({ left: direction * productRecommendationsScrollStep(track), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var detail = event.target.closest('[data-product-detail]');

    if (!detail) {
      return;
    }

    var openButton = event.target.closest('[data-gallery-open]');

    if (openButton) {
      var openIndex = Number(openButton.getAttribute('data-gallery-open'));
      setActiveMedia(detail, openIndex);
      openLightbox(detail, openIndex, openButton);
      return;
    }

    var closeButton = event.target.closest('[data-lightbox-close]');

    if (closeButton) {
      closeLightbox(detail);
      return;
    }

    var lightboxThumb = event.target.closest('[data-lightbox-thumb]');

    if (lightboxThumb) {
      setLightboxMedia(detail, Number(lightboxThumb.getAttribute('data-lightbox-thumb')));
      return;
    }

    var lightboxDirectionButton = event.target.closest('[data-lightbox-direction]');

    if (lightboxDirectionButton) {
      var lightboxPanels = detail.querySelectorAll('[data-lightbox-panel]');
      var activeLightboxPanel = detail.querySelector('[data-lightbox-panel]:not([hidden])');
      var activeLightboxIndex = Number(activeLightboxPanel && activeLightboxPanel.getAttribute('data-lightbox-panel')) || 0;
      var lightboxDirection = lightboxDirectionButton.getAttribute('data-lightbox-direction') === 'next' ? 1 : -1;
      var nextLightboxIndex = (activeLightboxIndex + lightboxDirection + lightboxPanels.length) % lightboxPanels.length;
      setLightboxMedia(detail, nextLightboxIndex);
      return;
    }

    var quantityButton = event.target.closest('[data-quantity-step]');

    if (quantityButton) {
      var input = detail.querySelector('[data-quantity-input]');
      var step = Number(quantityButton.getAttribute('data-quantity-step'));
      var nextValue = Math.max(1, Number(input.value || 1) + step);
      input.value = nextValue;
      return;
    }

    var thumb = event.target.closest('[data-gallery-thumb]');

    if (thumb) {
      setActiveMedia(detail, Number(thumb.getAttribute('data-gallery-thumb')));
      return;
    }

    var directionButton = event.target.closest('[data-gallery-direction]');

    if (directionButton) {
      var panels = detail.querySelectorAll('[data-gallery-panel]');
      var activePanel = detail.querySelector('[data-gallery-panel]:not([hidden])');
      var activeIndex = Number(activePanel && activePanel.getAttribute('data-gallery-panel')) || 0;
      var direction = directionButton.getAttribute('data-gallery-direction') === 'next' ? 1 : -1;
      var nextIndex = (activeIndex + direction + panels.length) % panels.length;
      setActiveMedia(detail, nextIndex);
    }
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('.product-detail__form');

    if (!form) {
      return;
    }

    var submitter = event.submitter || document.activeElement;

    if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) {
      return;
    }

    if (submitter && submitter.closest && submitter.type === 'submit' && !submitter.closest('[data-add-button]')) {
      return;
    }

    event.preventDefault();
    addProductToCart(form);
  });

  document.addEventListener('keydown', function(event) {
    var lightbox = document.querySelector('[data-product-lightbox]:not([hidden])');

    if (!lightbox) {
      return;
    }

    var detail = lightbox.closest('[data-product-detail]');

    if (!detail) {
      return;
    }

    if (event.key === 'Escape') {
      closeLightbox(detail);
      return;
    }

    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      return;
    }

    var panels = detail.querySelectorAll('[data-lightbox-panel]');
    var activePanel = detail.querySelector('[data-lightbox-panel]:not([hidden])');
    var activeIndex = Number(activePanel && activePanel.getAttribute('data-lightbox-panel')) || 0;
    var direction = event.key === 'ArrowRight' ? 1 : -1;
    var nextIndex = (activeIndex + direction + panels.length) % panels.length;

    setLightboxMedia(detail, nextIndex);
  });

  document.addEventListener('change', function(event) {
    var input = event.target.closest('[data-option-input]');

    if (!input) {
      return;
    }

    var detail = input.closest('[data-product-detail]');

    if (!detail) {
      return;
    }

    updateVariant(detail);
  });

  function setActiveMedia(detail, index) {
    detail.querySelectorAll('[data-gallery-panel]').forEach(function(panel) {
      var isActive = Number(panel.getAttribute('data-gallery-panel')) === index;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    detail.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb) {
      thumb.classList.toggle('is-active', Number(thumb.getAttribute('data-gallery-thumb')) === index);
    });

    setLightboxMedia(detail, index);
  }

  function openLightbox(detail, index, trigger) {
    var lightbox = detail.querySelector('[data-product-lightbox]');

    if (!lightbox) {
      return;
    }

    detail._lightboxTrigger = trigger;
    setLightboxMedia(detail, index);
    lightbox.hidden = false;
    document.body.classList.add('product-lightbox-open');

    var closeButton = lightbox.querySelector('.product-detail__lightbox-close');

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeLightbox(detail) {
    var lightbox = detail.querySelector('[data-product-lightbox]');

    if (!lightbox) {
      return;
    }

    lightbox.hidden = true;
    document.body.classList.remove('product-lightbox-open');

    if (detail._lightboxTrigger) {
      detail._lightboxTrigger.focus();
      detail._lightboxTrigger = null;
    }
  }

  function setLightboxMedia(detail, index) {
    var lightbox = detail.querySelector('[data-product-lightbox]');

    if (!lightbox) {
      return;
    }

    var panels = lightbox.querySelectorAll('[data-lightbox-panel]');
    var activePanel = null;

    panels.forEach(function(panel) {
      var isActive = Number(panel.getAttribute('data-lightbox-panel')) === index;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        activePanel = panel;
      }
    });

    if (activePanel) {
      prepareLightboxPanel(activePanel);
    }

    var stage = lightbox.querySelector('.product-detail__lightbox-stage');

    if (stage && !lightbox.hidden) {
      stage.classList.remove('is-switching');
      stage.offsetWidth;
      stage.classList.add('is-switching');
      window.setTimeout(function() {
        stage.classList.remove('is-switching');
      }, 260);
    }

    lightbox.querySelectorAll('[data-lightbox-thumb]').forEach(function(thumb) {
      thumb.classList.toggle('is-active', Number(thumb.getAttribute('data-lightbox-thumb')) === index);
    });

    var counter = lightbox.querySelector('[data-lightbox-counter]');

    if (counter) {
      counter.textContent = (index + 1) + ' / ' + panels.length;
    }
  }

  function prepareLightboxPanel(panel) {
    var image = panel.querySelector('.product-detail__lightbox-image');

    if (!image || image.tagName !== 'IMG') {
      panel.classList.remove('is-loading');
      return;
    }

    if (image.dataset.lightboxLoaded === 'true' || image.complete && image.naturalWidth > 0) {
      image.dataset.lightboxLoaded = 'true';
      panel.classList.remove('is-loading');
      return;
    }

    panel.classList.add('is-loading');
    image.loading = 'eager';
    image.decoding = 'async';

    if (image.dataset.lightboxLoadBound === 'true') {
      return;
    }

    image.dataset.lightboxLoadBound = 'true';

    var markLoaded = function() {
      image.dataset.lightboxLoaded = 'true';
      panel.classList.remove('is-loading');
    };

    image.addEventListener('load', markLoaded, { once: true });
    image.addEventListener('error', markLoaded, { once: true });

    if (image.decode) {
      image.decode().then(markLoaded).catch(function() {});
    }
  }

  function addProductToCart(form) {
    var detail = form.closest('[data-product-detail]');
    var button = form.querySelector('[data-add-button]');

    if (!detail || !button || button.disabled) {
      return;
    }

    if (form.reportValidity && !form.reportValidity()) {
      return;
    }

    setAddButtonLoading(button);

    fetch(getJsonEndpoint(form.getAttribute('action') || '/cart/add'), {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(form)
    })
      .then(parseCartResponse)
      .then(function() {
        setAddButtonSuccess(detail, button);
        animateCartFlyer(button);
        return refreshHeaderCartCount();
      })
      .catch(function(error) {
        console.warn(error);
        resetAddButton(detail, button);
      });
  }

  function parseCartResponse(response) {
    return response.json().catch(function() {
      return {};
    }).then(function(json) {
      if (!response.ok) {
        throw new Error(json.description || json.message || 'Unable to add product to cart.');
      }

      return json;
    });
  }

  function getJsonEndpoint(path) {
    var url = new URL(path, window.location.origin);

    if (!url.pathname.endsWith('.js')) {
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    }

    return url.toString();
  }

  function setAddButtonLoading(button) {
    button.classList.remove('is-added');
    button.classList.add('is-loading');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  }

  function setAddButtonSuccess(detail, button) {
    var label = button.querySelector('[data-add-label]');

    window.clearTimeout(button._addResetTimer);
    button.dataset.addLocked = 'true';
    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.disabled = true;
    button.setAttribute('aria-busy', 'false');

    if (label) {
      label.textContent = button.dataset.addedLabel || 'Added to Cart';
    }

    button._addResetTimer = window.setTimeout(function() {
      resetAddButton(detail, button);
    }, 3000);
  }

  function resetAddButton(detail, button) {
    var label = button.querySelector('[data-add-label]');
    var selectedOption = detail.querySelector('[data-variant-select] option:checked');
    var available = !selectedOption || selectedOption.dataset.available === 'true';

    window.clearTimeout(button._addResetTimer);
    button.classList.remove('is-loading', 'is-added');
    button.removeAttribute('aria-busy');
    delete button.dataset.addLocked;
    button.disabled = !available;

    if (label) {
      label.textContent = available ? label.dataset.availableLabel || label.textContent : detail.dataset.soldOutLabel;
    }
  }

  function animateCartFlyer(button) {
    var target = document.querySelector('[data-header-cart]');
    var icon = button.querySelector('.product-detail__add-icon--cart svg');

    if (!target || !icon) {
      return;
    }

    var sourceRect = button.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var sourceX = sourceRect.left + sourceRect.width / 2;
    var sourceY = sourceRect.top + sourceRect.height / 2;
    var targetX = targetRect.left + targetRect.width / 2;
    var targetY = targetRect.top + targetRect.height / 2;
    var flyer = document.createElement('span');

    flyer.className = 'product-detail__cart-flyer';
    flyer.style.left = sourceX + 'px';
    flyer.style.top = sourceY + 'px';
    flyer.appendChild(icon.cloneNode(true));
    document.body.appendChild(flyer);

    if (flyer.animate) {
      flyer.animate([
        {
          left: sourceX + 'px',
          top: sourceY + 'px',
          opacity: 1,
          transform: 'translate(-50%, -50%) scale(1) rotate(0deg)'
        },
        {
          left: sourceX + (targetX - sourceX) * 0.58 + 'px',
          top: sourceY + (targetY - sourceY) * 0.34 - 52 + 'px',
          opacity: 1,
          transform: 'translate(-50%, -50%) scale(0.82) rotate(8deg)'
        },
        {
          left: targetX + 'px',
          top: targetY + 'px',
          opacity: 0.24,
          transform: 'translate(-50%, -50%) scale(0.34) rotate(-10deg)'
        }
      ], {
        duration: 760,
        easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
      }).onfinish = function() {
        flyer.remove();
        pingHeaderCart(target);
      };
    } else {
      window.requestAnimationFrame(function() {
        flyer.style.transition = 'left 760ms cubic-bezier(0.16, 1, 0.3, 1), top 760ms cubic-bezier(0.16, 1, 0.3, 1), opacity 760ms ease, transform 760ms cubic-bezier(0.16, 1, 0.3, 1)';
        flyer.style.left = targetX + 'px';
        flyer.style.top = targetY + 'px';
        flyer.style.opacity = '0.24';
        flyer.style.transform = 'translate(-50%, -50%) scale(0.34) rotate(-10deg)';
      });

      window.setTimeout(function() {
        flyer.remove();
        pingHeaderCart(target);
      }, 800);
    }
  }

  function refreshHeaderCartCount() {
    var target = document.querySelector('[data-header-cart]');

    if (!target) {
      return Promise.resolve();
    }

    return fetch(getJsonEndpoint(target.getAttribute('href') || '/cart'), {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(parseCartResponse)
      .then(function(cart) {
        updateHeaderCartCount(target, cart.item_count || 0);
      })
      .catch(function(error) {
        console.warn(error);
      });
  }

  function updateHeaderCartCount(target, count) {
    var bubble = target.querySelector('[data-cart-count]');

    if (count <= 0) {
      if (bubble) {
        bubble.remove();
      }

      return;
    }

    if (!bubble) {
      bubble = document.createElement('span');
      bubble.dataset.cartCount = '';
      target.appendChild(bubble);
    }

    bubble.textContent = count;
  }

  function pingHeaderCart(target) {
    window.clearTimeout(target._cartPingTimer);
    target.classList.remove('is-cart-ping');
    target.offsetWidth;
    target.classList.add('is-cart-ping');
    target._cartPingTimer = window.setTimeout(function() {
      target.classList.remove('is-cart-ping');
    }, 560);
  }

  function updateVariant(detail) {
    var variantsScript = detail.querySelector('[data-product-variants]');
    var variantSelect = detail.querySelector('[data-variant-select]');

    if (!variantsScript || !variantSelect) {
      return;
    }

    var variants = JSON.parse(variantsScript.textContent);
    var selectedOptions = [];

    detail.querySelectorAll('[data-option-input]').forEach(function(input) {
      var position = Number(input.getAttribute('data-option-position')) - 1;

      if (input.type === 'radio' && !input.checked) {
        return;
      }

      selectedOptions[position] = input.value;
    });

    var selectedVariant = variants.find(function(variant) {
      return variant.options.every(function(option, index) {
        return option === selectedOptions[index];
      });
    });

    if (!selectedVariant) {
      return;
    }

    variantSelect.value = selectedVariant.id;
    var selectedOption = variantSelect.querySelector('option[value="' + selectedVariant.id + '"]');
    var price = detail.querySelector('[data-product-price]');
    var stock = detail.querySelector('[data-stock-message]');
    var addButton = detail.querySelector('[data-add-button]');
    var addLabel = detail.querySelector('[data-add-label]');

    if (selectedOption && price) {
      price.textContent = selectedOption.dataset.price;
    }

    if (selectedOption && stock) {
      var available = selectedOption.dataset.available === 'true';
      var inventory = Number(selectedOption.dataset.inventory || 0);
      var lowStockThreshold = Number(detail.dataset.lowStockThreshold || 8);
      var lowStockTemplate = detail.dataset.lowStockTemplate;
      var inStockLabel = detail.dataset.inStockLabel;
      var soldOutLabel = detail.dataset.soldOutLabel;

      if (available) {
        stock.innerHTML = '<strong>' + inStockLabel + '</strong>';

        if (inventory > 0 && inventory <= lowStockThreshold) {
          stock.innerHTML += '<span>' + lowStockTemplate.replace('[count]', inventory) + '</span>';
        }
      } else {
        stock.innerHTML = '<strong>' + soldOutLabel + '</strong>';
      }

      if (addButton && addButton.dataset.addLocked !== 'true') {
        addButton.disabled = !available;
      }

      if (addLabel && (!addButton || addButton.dataset.addLocked !== 'true')) {
        addLabel.textContent = available ? addLabel.dataset.availableLabel || addLabel.textContent : soldOutLabel;
      }
    }

    if (selectedVariant.featured_media && selectedVariant.featured_media.id) {
      var targetPanel = detail.querySelector('[data-gallery-panel][data-media-id="' + selectedVariant.featured_media.id + '"]');

      if (targetPanel) {
        setActiveMedia(detail, Number(targetPanel.getAttribute('data-gallery-panel')));
      }
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', selectedVariant.id);
    window.history.replaceState({}, '', url.toString());
  }

  } catch(e) { console.error(e); }
})();
})();
